import { markRaw } from 'vue'
import { Registerable } from '@baserow/modules/core/registry'
import { integrationsErrorMessage } from '@baserow/modules/core/utils/integration'
import GeneralSettingsComponent from '@baserow/modules/automation/components/settings/GeneralSettings'
import IntegrationSettingsComponent from '@baserow/modules/automation/components/settings/IntegrationSettings'

const GeneralSettings = markRaw(GeneralSettingsComponent)
const IntegrationSettings = markRaw(IntegrationSettingsComponent)

class AutomationSettingType extends Registerable {
  static getType() {
    return null
  }

  get name() {
    return null
  }

  get icon() {
    return null
  }

  isDeactivated() {
    return false
  }

  get component() {
    return null
  }

  get componentPadding() {
    return true
  }

  /**
   * Returns why this setting contains something that needs the user's
   * attention, or null when nothing does. Used to flag the setting, and the
   * "Settings" entry leading to it, so the user can follow the trail to the
   * issue.
   *
   * @param {object} application The application the setting belongs to.
   * @returns {string|null} The error message, if any.
   */
  getErrorMessage(application) {
    return null
  }

  /**
   * Override `getErrorMessage` instead of this method so a setting in error
   * also provides a user-facing explanation.
   *
   * @param {object} application The application the setting belongs to.
   * @returns {boolean} If the setting is in error.
   */
  isInError(application) {
    return Boolean(this.getErrorMessage(application))
  }
}

export class GeneralAutomationSettingsType extends AutomationSettingType {
  static getType() {
    return 'general'
  }

  get name() {
    return this.app.$i18n.t('builderSettingTypes.generalName')
  }

  get icon() {
    return 'iconoir-settings'
  }

  isDeactivated() {
    return import.meta.env.MODE !== 'development'
  }

  getOrder() {
    return 1
  }

  get component() {
    return GeneralSettings
  }
}

export class IntegrationsAutomationSettingsType extends AutomationSettingType {
  static getType() {
    return 'integrations'
  }

  get name() {
    return this.app.$i18n.t('builderSettingTypes.integrationsName')
  }

  get icon() {
    return 'iconoir-ev-plug'
  }

  getOrder() {
    return 10
  }

  get component() {
    return IntegrationSettings
  }

  getErrorMessage(application) {
    return integrationsErrorMessage(this.app, application.integrations)
  }
}
